












































import { Vue, Component } from 'vue-property-decorator';
import scratchCard from 'lzy-scratch-card';
import { getPrize, getRes, getMess, ifMess, getAddr, userPrize } from '../api';
import { isWeiXin } from '@/common/ts/common';
import { Dialog, Toast } from 'vant';
import qs from 'qs';
Vue.use(Dialog).use(Toast);
@Component({
  components: {
    scratchCard,
  },
})
export default class Prize extends Vue {
  result: string = '';
  unionId: any = '';
  text: string = '';
  show: boolean = false;
  name: string = '';
  phone: string = '';
  code: boolean = false;
  mess: boolean = false;
  text2: string = '';
  text3: string = '领取';
  text2Show: boolean = true;
  img: string = require('../assets/back.png');
  async created() {
    this.WechatLogin();
    if (isWeiXin()) {
      this.unionId = window.localStorage.getItem('unionid');
      const data = {
        unionid: this.unionId,
      };
      const res: any = await getPrize(data);
      const mess: any = await ifMess(data);
      this.mess = mess.data;
      const prize: any = await userPrize(data);
      this.getAddr();
      if (prize.code === 200) {
        this.text2 = prize.data;
      } else {
        this.text2Show = false;
      }
    } else if (window.udid) {
      const data = {
        udid: window.udid,
        appkey: window.appkey,
        token: window.gettoken(),
      };
      const userLogin = window.gettoken() && window.gettoken() !== 'null';
      if (window.udid && !userLogin) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
        return false;
      } else {
        const res: any = await getPrize(data);
        const mess: any = await ifMess(data);
        this.mess = mess.data;
        const prize: any = await userPrize(data);
        this.getAddr();
        if (prize.code === 200) {
          this.text2 = prize.data;
        } else {
          this.text2Show = false;
        }
      }
    }
    if (this.$route.query.id === '2') {
      Toast('请先参与点赞');
    }
  }
  async startCallback() {
    if (isWeiXin()) {
      this.unionId = window.localStorage.getItem('unionid');
      const data = {
        unionid: this.unionId,
      };
      const res: any = await getRes(data);
      if (res.code === 400) {
        this.result = `<p style="height:100%;width:100%;display:flex;justify-content:center;align-items:center;color:#000;font-size:20px;text-align:center;background:url(${this.img});background-size:cover;background-position:center;border-radius:12px;"><span>${res.data}<span></p>`;
      } else if (res.code === 200) {
        this.result = `<p style="height:100%;width:100%;display:flex;justify-content:center;align-items:center;color:#000;font-size:20px;text-align:center;background:url(${this.img});background-size:cover;background-position:center;border-radius:12px;"><span>${res.data}<span></p>`;
        this.code = true;
      } else if (res.code === 500) {
        this.result = `<p style="height:100%;width:100%;display:flex;justify-content:center;align-items:center;color:#000;font-size:20px;text-align:center;background:url(${this.img});background-size:cover;background-position:center;border-radius:12px;"><span>未中奖<span></p>`;
      } else {
        this.result = `<p style="height:100%;width:100%;display:flex;justify-content:center;align-items:center;color:#000;font-size:20px;text-align:center;background:url(${this.img});background-size:cover;background-position:center;border-radius:12px;"><span>${res.data}<span></p>`;
      }
    } else if (window.udid) {
      const data = {
        udid: window.udid,
        appkey: window.appkey,
        token: window.gettoken(),
      };
      const res: any = await getRes(data);
      if (res.code === 400) {
        this.result = `<p style="height:100%;width:100%;display:flex;justify-content:center;align-items:center;color:#000;font-size:20px;text-align:center;background:url(${this.img});background-size:cover;background-position:center;border-radius:12px;"><span>${res.data}<span></p>`;
      } else if (res.code === 200) {
        this.result = `<p style="height:100%;width:100%;display:flex;justify-content:center;align-items:center;color:#000;font-size:20px;text-align:center;background:url(${this.img});background-size:cover;background-position:center;border-radius:12px;"><span>${res.data}<span></p>`;
        this.code = true;
      } else {
        this.result = `<p style="height:100%;width:100%;display:flex;justify-content:center;align-items:center;color:#000;font-size:20px;text-align:center;background:url(${this.img});background-size:cover;background-position:center;border-radius:12px;"><span>${res.data}<span></p>`;
      }
    }
  }
  clearCallbackUp() {
    if (this.code) {
      this.show = true;
    }
  }
  WechatLogin() {
    const unionid = window.localStorage.getItem('unionid');
    if (!unionid) {
      if (isWeiXin() || !window.udid) {
        const appId = 'wx1949ed4a473b87ed';
        location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
          location.href,
        )}`;
      }
    }
  }
  async close() {
    if (!this.name) {
      Toast('请输入姓名');
      return false;
    } else if (!this.phone) {
      Toast('请输入电话');
      return false;
    } else if (!/^1[345789][0-9]{9}$/.test(this.phone)) {
      Toast('电话号码错误');
      return false;
    } else {
      const data = {
        udid: window.udid,
        appkey: window.appkey,
        token: window.gettoken(),
        unionid: this.unionId,
        name: this.name,
        phone: this.phone,
      };
      const res: any = await getMess(data);
      if (res.code === 200) {
        Toast(`${res.msg}`);
        this.text3 = '已领取';
      } else {
        Toast(`${res.msg}`);
      }
    }
  }
  async getAddr() {
    const data = {
      udid: window.udid,
      appkey: window.appkey,
      token: window.gettoken(),
      unionid: this.unionId,
    };
    const res: any = await getAddr(data);
    if (res.data) {
      this.text3 = '已领取';
    }
  }
}
